<div class="flex items-center relative w-full">
  <div class="relative w-[inherit]">
    <input
      autofocus
      #inputSearch
      (keyup.enter)="addFilterValue(filterType.contain); showFilterMenu = true"
      [(ngModel)]="searchValue"
      [disabled]="disabled"
      class="m-input pe-[3.5rem] {{
        totalKeywords > 0 ? 'placeholder:text-gray-1000' : ''
      }}"
      id="search-input"
      pInputText
      placeholder="{{
        totalKeywords > 0
          ? totalKeywords + (totalKeywords > 1 ? ' keywords' : ' keyword')
          : 'Search'
      }}" />
    <span class="flex gap-1 items-center absolute right-2 top-[6px]">
      @if (!searchValue?.length && !showFilterMenu) {
        <span
          class="material-symbols-outlined search-inline-button inline-search-icon"
          (click)="showFilterMenu = totalKeywords > 0">
          search
        </span>
      }
      @if (!searchValue?.length && showFilterMenu && totalKeywords > 0) {
        <span
          class="material-symbols-outlined search-inline-button inline-search-icon"
          (click)="showFilterMenu = false">
          keyboard_arrow_up
        </span>
      }
      @if (searchValue?.length) {
        <span
          class="material-symbols-outlined search-inline-button add-icon"
          (click)="
            $event.stopImmediatePropagation();
            showFilterMenu = true;
            inputSearch.click();
            addFilterValue(filterType.contain)
          ">
          add
        </span>
      }
      @if (searchValue?.length) {
        <span
          class="material-symbols-outlined search-inline-button remove-icon"
          (click)="
            $event.stopImmediatePropagation();
            showFilterMenu = true;
            inputSearch.click();
            addFilterValue(filterType.exclude)
          ">
          remove
        </span>
      }
    </span>
    <div
      [ngTemplateOutlet]="filterKeywords"
      class="absolute left-0 top-[3rem] z-50"></div>
  </div>
</div>
<ng-template #filterKeywords>
  @if (showFilterMenu && totalKeywords > 0) {
    <div class="filter-menu flex flex-col gap-2 justify-between">
      <div class="flex flex-col w-full gap-2 filter-items">
        @for (group of filterValues; track group) {
          @if (group.items?.length) {
            <div class="filter-menu-group gap-2">
              <span
                class="material-symbols-outlined {{
                  group.iconClass
                }}-icon text-gray-500"
                >{{ group.iconClass }}</span
              >
              <span class="b1 text-gray-800">{{
                group.label | titlecase
              }}</span>
            </div>
          }
          @if (group.items?.length) {
            <div class="flex gap-2 flex-wrap">
              @for (value of group.items; track value) {
                <m-chip
                  [label]="value"
                  [removable]="true"
                  (remove)="removeFilterValue($event, group.label)"></m-chip>
              }
            </div>
          }
        }
      </div>
      <div class="filter-menu-footer">
        <m-button (click)="publishFilter()">Search</m-button>
      </div>
    </div>
  }
</ng-template>
